import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import PropTypes from "prop-types"

import Row from "../../../common/components/Row"

export default function AdminZohoMailboxRowActions({ row, onEdit, onDelete }) {
  const isActive = row.status === "active"

  return (
    <Row gap={0.5} justifyContent="flex-end">
      <Tooltip title="Reassign concierge / parent account">
        <IconButton
          size="small"
          aria-label="Edit Zoho mailbox assignment"
          onClick={() => onEdit(row)}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={
          isActive
            ? "Disable in Zoho Mail and disconnect in OneBase"
            : "Already disabled"
        }
      >
        <span>
          <IconButton
            size="small"
            color="error"
            aria-label="Delete Zoho mailbox"
            disabled={!isActive}
            onClick={() => onDelete(row)}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Row>
  )
}

AdminZohoMailboxRowActions.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
